import "./theme/theme.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { NavBar } from "./components/NavBar";
import { About } from "./components/About";
import { Banner } from "./components/Banner";
import { Projects } from "./components/Projects";
// import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Technologies } from "./components/Technologies";
import { Experience } from "./components/Experience";
import { Testimonials } from "./components/Testimonials";
import { ContactMe } from "./components/ContactMe";
// import { ContactMe3 } from "./components/ContactMe3";
import ScrollButton from "./components/ScrollButton/ScrollButton";
import WhatsAppButton from "./components/WhatsAppButton/WhatsAppButton";

import { ThemeProvider } from "./context/ThemeContext";

import { ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AppContent() {
  return (
    <div className="App">
      <WhatsAppButton />
      <ScrollButton />
      <NavBar />
      <Banner />
      <About />
      <Technologies />
      <Experience />
      <Projects />
      <Testimonials />
      <ContactMe />
      {/* <ContactMe3 /> */}
      {/* <Contact /> */}
      <Footer />

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
        theme="dark"
        transition={Bounce}
      />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
